import React, { useState, useEffect } from "react";
import Mobile from "./mobile";
import Web from "./web/index";
import Logo from "../../logo.png";


function Header() {
  const [top, setTop] = useState(true);

  useEffect(() => {
    const scrollHandler = () => {
      window.pageYOffset > 10 ? setTop(false) : setTop(true)
    };
    window.addEventListener('scroll', scrollHandler);
    return () => window.removeEventListener('scroll', scrollHandler);
  }, [top]);
  const [isOpen, setIsOpen]=useState(false);

  return (
    <div className="flex justify-between flex-1 pt-3 pr-4 fixed items-center w-full bg-white shadow-md">
      <div className="flex ml-10 pb-2"><img src={Logo} alt="Christopher Nez" className="w-40 mt-3"/></div>
      <div className="bg-white flex flex-1 justify-end md:justify-center">
        <div className="hidden md:flex ml-96">
          <Web />
        </div>
        <div className="flex md:hidden">
          <div onClick={()=>setIsOpen(!isOpen)}>
            <i class="fi-rr-apps text-3xl"></i>
          </div>
          {isOpen && <Mobile isOpen={isOpen} setIsOpen={setIsOpen} />}
        </div>
      </div>
    </div>
  );
}

export default Header;